import * as store from '@attain-apps/fe/web/main/lib/store'

import type * as models from './models'
import { State } from './state'

/**
 * Core actions for the Sibling Users feature.
 */
export function getActionsConfig() {
  return {
    /** Clears the list when the active portal context changes. */
    clear: store.actions.standalone({
      data: store.actions.Data.NONE,
      reducer: () => State.INITIAL,
    }),
    /** Retrieves users assigned to the currently applied portal context. */
    get: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.asIs<readonly models.User[]>(),
      reducers: {
        request: () => ({
          ...State.INITIAL,
          users: { isLoading: true },
        }),
        success: ({ data: { response } }) => ({
          users: { data: response },
        }),
        error: ({ data: { error } }) => ({
          users: { error },
        }),
        cancellation: () => State.INITIAL,
      },
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
